import React from "react";
import {Link} from "react-router-dom";
import {mail, phone_number} from "../configurationConstant";

const visa = require('../images/visa-256.png');
const master_card = require('../images/_Mastercard-256.png');
const instagram = require('../images/instagram-round-flat-256.png');
const vk = require('../images/vk-256.png');
const twitter = require('../images/twitter-256.png');
const google = require('../images/social-03-256.png');
const facebook = require('../images/facebook_circle-256.png');


export class Footer extends React.Component{
    render(){
        return(
            <footer id={'footer'}>
                <div>
                    <div id={'footer_FAQ'}>
                        <div>
                            <div>
                                <div className={'footer_link'}>
                                    <Link to={'/Engineer.html'}  onClick={() => window.location.href = '/Engineer.html'}>Как стать инженером</Link>
                                    <Link to={'/Customer.html'} onClick={() => window.location.href = '/Customer.html'}>Как стать заказчиком</Link>
                                    <Link to={'/Specifications.html'} onClick={() => window.location.href = '/Specifications.html'}>Сертификация инжинеров</Link>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div>
                                <div className={'footer_link'}>
                                    <Link to={'/AboutUS.html'} onClick={() => window.location.href = '/AboutUS.html'}>О сервисе</Link>
                                    <Link to={'/Shares.html'} onClick={() => window.location.href = '/Shares.html'}>Акции</Link>
                                    <Link to={'/AboutCompany.html'} onClick={() => window.location.href = '/AboutCompany.html'}>О компании</Link>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div>
                                <div className={'footer_link'}>
                                    <Link to={'/Warranty.html'} onClick={() => window.location.href = '/Warranty.html'}>Гарантии</Link>
                                    <Link to={'/Payment.html'} onClick={() => window.location.href = '/Payment.html'}>Оплата</Link>
                                    <Link to={'/FAQ.html'} onClick={() => window.location.href = '/FAQ.html'}>Вопрос-ответ</Link>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div>
                                <div className={'footer_link'}>
                                    <Link to={'/Review.html'} onClick={() => window.location.href = '/Review.html'}>Отзывы</Link>
                                    <Link to={'/News.html'} onClick={() => window.location.href = '/News.html'}>Новости</Link>
                                    <Link to={'/Blog.html'} onClick={() => window.location.href = '/Blog.html'}>Блог</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id={"footer_info"}>
                    <div>
                        <div><a href={'tel: ' + phone_number.number}><span>{phone_number.text}</span></a></div>
                        <div><a href={'mailto: ' + mail}><p>{mail}</p></a></div>
                        <div>
                            <p>Способы оплаты</p>
                            <div className={'footer_payment'}>
                                <img src={master_card} alt={""}/>
                            </div>
                            <div className={'footer_payment'}>
                                <img src={visa} alt={""}/>
                            </div>
                        </div>
                        <div>
                            <a href={''}>
                                <img className={'footer_social'} src={vk} alt={""}/>
                            </a>
                            <a href={''}>
                                <img className={'footer_social'} src={facebook} alt={""}/>
                            </a>
                            <a href={''}>
                                <img className={'footer_social'} src={twitter} alt={""}/>
                            </a>
                            <a href={''}>
                                <img className={'footer_social'} src={google} alt={""}/>
                            </a>
                            <a href={''}>
                                <img className={'footer_social'} src={instagram} alt={""}/>
                            </a>
                        </div>
                    </div>
                </div>
                <div id={'footer_legal'}>
                    <div>
                        <p>ⒸТД "Тонер" 2007-2019. Все права защищены</p>
                        <p>Политика в отношении обработки персональных данных</p>
                        <p>Карта сайта</p>
                    </div>
                </div>
            </footer>
        )
    }
}
